import { reactive } from 'vue';

import { getFileRequest } from '@/core/http-methods';

const objectUrlCache = new Map<string, Promise<string>>();
const resolvedUrls = reactive<Record<string, string>>({});
const startedUrls = new Set<string>();

export function isRadarFileUrl(url: string | null | undefined): boolean {
	if (!url) return false;
	const base = import.meta.env.VITE_RADAR_URL as string | undefined;
	if (!base) return false;
	return url.startsWith(base);
}

export function authorizedSrc(url: string | null | undefined): string {
	if (!url || !url.trim()) return '';
	if (!isRadarFileUrl(url)) return url;
	if (resolvedUrls[url]) return resolvedUrls[url];

	if (!startedUrls.has(url)) {
		startedUrls.add(url);
		void resolveAuthorizedFileUrl(url)
			.then((objectUrl) => {
				resolvedUrls[url] = objectUrl;
			})
			.catch(() => {
				startedUrls.delete(url);
			});
	}

	return '';
}

export function resolveAuthorizedFileUrl(url: string): Promise<string> {
	const cached = objectUrlCache.get(url);
	if (cached) return cached;

	const pending = fetchAuthorizedObjectUrl(url).catch((error: unknown) => {
		objectUrlCache.delete(url);
		throw error;
	});
	objectUrlCache.set(url, pending);
	return pending;
}

async function fetchAuthorizedObjectUrl(url: string): Promise<string> {
	const response = await getFileRequest(url);
	const data = response.body as unknown;
	if (response.status !== 200 || !(data instanceof Blob)) {
		throw new Error(`Failed to fetch file: ${response.status}`);
	}
	return URL.createObjectURL(data);
}
